module.exports = __webpack_public_path__ + "chat_interface.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/chat_interface.jpg
// module id = 2190
// module chunks = 13